import i18n from '../../utils/i18n';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import isNullOrUndefined from '@adsk/bim360-matrix-react-helpers/es/isNullOrUndefined';
import lodashIsEqual from 'lodash/isEqual';
import lodashGet from 'lodash/get';

import {
  showNotificationAction,
  trackEvent,
  fetchIssueAttributesMappingsAction,
  fetchIssueAttributesDefinitionsAction,
  setSelectedIssueTypeAttributesAction,
  selectIssueTypeForEdit,
  updateIssueTypeAttributesAction,
  fetchIssueTypesAction,
  showIssueTypeUpdatedNotificationAction,
  ISSUE_SUB_TYPES_CREATE_API,
  ISSUE_SUB_TYPES_CREATE_API_REJECTED,
  ISSUE_SUB_TYPES_CREATE_START,
  ISSUE_TYPES_CREATE_API,
  ISSUE_TYPES_CREATE_API_FULFILLED,
  ISSUE_TYPES_CREATE_API_REJECTED,
  ISSUE_TYPES_CREATE_START,
  ISSUE_TYPES_FETCH_API,
  ISSUE_TYPES_FETCH_START,
  ISSUE_TYPES_UPDATE_STATUS_API,
  ISSUE_TYPES_UPDATE_STATUS_API_REJECTED,
  ISSUE_TYPES_UPDATE_STATUS_START,
  ISSUE_TYPES_UPDATE_TITLE_API,
  ISSUE_TYPES_UPDATE_TITLE_API_REJECTED,
  ISSUE_TYPES_UPDATE_TITLE_START,
  ISSUE_TYPES_UPDATE_API,
  ISSUE_TYPES_UPDATE_API_FULFILLED,
  ISSUE_TYPES_UPDATE_API_REJECTED,
  ISSUE_TYPES_UPDATE_START,
  ISSUE_SUB_TYPES_CREATE_API_FULFILLED,
  ISSUE_TYPES_UPDATE_STATUS_API_FULFILLED,
  ISSUE_TYPES_FETCH_API_FULFILLED,
  ISSUE_TYPES_SELECT_FOR_EDIT,
  ISSUE_TYPES_REMOVE_SELECTED_ATTRIBUTE,
  ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_DEFINITIONS,
  SHOW_ISSUE_TYPES_EDIT_MODAL,
  ISSUE_ATTRIBUTES_MAPPINGS_FETCH_FINISHED,
  ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API_REJECTED,
  ISSUE_TYPES_SET_ATTRIBUTE_MAPPINGS,
  FIELD_ISSUES_FETCH_CUSTOMIZATION_METADATA,
  ISSUE_TYPES_UPDATE_NOTIFICATION_SHOW
} from '../actions';
import {
  FIELD_TRACK_EVENT,
  issueAllIssuesTypesModalVisit,
  issueSubTypeCreate,
  issueSubTypeSetStatusChanged,
  issueTypeCreate,
  issueTypeSetStatusChanged
} from '../../utils/analytics-helpers';
import {
  getFilteredIssueTypeAttributeMappingsByIssueTypeId,
  getCurrentEditingIssueTypeAttributeMappings,
  getIssueAttributesMappingsMappedEntities,
  getIssueTypeById,
  getSelectedIssueTypeAttributes,
  getContainerId,
  isIssueTypesAdminListFetched,
  isIssueAttributesMappingsFetched,
  isIssueAttributesDefinitionsFetched,
  isLoadingIssueAttributesDefinitions,
  getPendingIssueType,
  getIssueTypeForEdit,
  isLoadingIssueAttributesMappings,
  isLoadingIssueTypesAdminList,
  getIssueAttributesDefinitionsEntitiesMap
} from '../selectors';
import {isStandardType} from '../../utils/issueTypes-helpers';

export default issuesV2Api => store => next => action => {
  const state = store.getState();
  const handleIssueTypeStatusUpdateFulfilled = () => {
    const issueType = getIssueTypeById(state, action.meta.id);
    const isStandard = issueType && isStandardType(issueType);
    if (action.meta.parentId) {
      const parent = getIssueTypeById(state, action.meta.parentId);
      const isParentStandard = parent && isStandardType(parent);
      store.dispatch(
        trackEvent(issueSubTypeSetStatusChanged(isStandard, isParentStandard, action.meta.isActive), FIELD_TRACK_EVENT)
      );
    } else {
      store.dispatch(trackEvent(issueTypeSetStatusChanged(isStandard, action.meta.isActive), FIELD_TRACK_EVENT));
    }
  };
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ISSUE_TYPES_FETCH_START: {
      store.dispatch({
        type: ISSUE_TYPES_FETCH_API,
        payload: issuesV2Api.getIssueTypes(),
        meta: {containerId: getContainerId(state)}
      });
      break;
    }
    // For more info, see documentation of FIELD_ISSUES_FETCH_CUSTOMIZATION_METADATA
    case ISSUE_TYPES_FETCH_API_FULFILLED:
      !isLoadingIssueAttributesDefinitions(state) &&
        !isIssueAttributesMappingsFetched(state) &&
        !isLoadingIssueAttributesMappings(state) &&
        store.dispatch(fetchIssueAttributesMappingsAction());
      break;
    case ISSUE_TYPES_CREATE_START: {
      store.dispatch({
        type: ISSUE_TYPES_CREATE_API,
        meta: {
          title: action.payload.title,
          isActive: action.payload.isActive,
          statusSet: action.payload.statusSet,
          containerId: getContainerId(state),
          onSuccess: action.meta.onSuccess
        },
        payload: issuesV2Api.createIssueType(action.payload)
      });
      break;
    }
    case ISSUE_SUB_TYPES_CREATE_START: {
      store.dispatch({
        type: ISSUE_SUB_TYPES_CREATE_API,
        meta: {
          title: action.payload.title,
          parentId: action.payload.parentId,
          isActive: action.payload.isActive,
          clientID: action.payload.clientID
        },
        payload: issuesV2Api.createIssueSubType(action.payload)
      });
      break;
    }
    case ISSUE_TYPES_CREATE_API_FULFILLED: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.TOAST,
          level: NotificationLevels.SUCCESS,
          message: i18n.t('issueTypes.notifications.createSuccessIssueType', {
            issueTypeName: action.meta.title
          })
        })
      );
      store.dispatch(
        trackEvent(issueTypeCreate(action.meta.isActive, action.meta.title, action.meta.statusSet), FIELD_TRACK_EVENT)
      );
      action.meta.onSuccess && action.meta.onSuccess();
      break;
    }
    case ISSUE_TYPES_CREATE_API_REJECTED: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message: i18n.t('issueTypes.notifications.createErrorIssueType', {
            issueTypeName: action.meta.title
          })
        })
      );
      break;
    }
    case ISSUE_SUB_TYPES_CREATE_API_FULFILLED: {
      const parent = getIssueTypeById(state, action.meta.parentId);
      const isParentStandard = parent && isStandardType(parent);
      store.dispatch(
        trackEvent(
          issueSubTypeCreate(isParentStandard, action.meta.isActive, action.meta.title, parent.title),
          FIELD_TRACK_EVENT
        )
      );
      break;
    }
    case ISSUE_SUB_TYPES_CREATE_API_REJECTED: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message: i18n.t('issueTypes.notifications.createErrorIssueSubType', {
            issueTypeName: action.meta.title
          })
        })
      );
      break;
    }
    case ISSUE_TYPES_UPDATE_STATUS_START: {
      store.dispatch({
        type: ISSUE_TYPES_UPDATE_STATUS_API,
        payload: issuesV2Api.updateIssueType(action.payload.id, action.payload.parentId, {
          isActive: action.payload.isActive
        }),
        meta: {
          id: action.payload.id,
          parentId: action.payload.parentId,
          isActive: action.payload.isActive
        }
      });
      break;
    }
    case ISSUE_TYPES_UPDATE_STATUS_API_FULFILLED: {
      handleIssueTypeStatusUpdateFulfilled();
      store.dispatch(showIssueTypeUpdatedNotificationAction(!!action.meta.parentId));
      break;
    }
    case ISSUE_TYPES_UPDATE_STATUS_API_REJECTED: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message: action.meta.parentId
            ? i18n.t('issueTypes.notifications.updateStatusErrorIssueSubType')
            : i18n.t('issueTypes.notifications.updateStatusErrorIssueType')
        })
      );
      break;
    }
    case ISSUE_TYPES_UPDATE_TITLE_START: {
      store.dispatch({
        type: ISSUE_TYPES_UPDATE_TITLE_API,
        payload: issuesV2Api.updateIssueType(action.payload.id, action.payload.parentId, {
          title: action.payload.title
        })
      });
      break;
    }
    case ISSUE_TYPES_UPDATE_TITLE_API_REJECTED: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message:
            action.meta && action.meta.parentId
              ? i18n.t('issueTypes.notifications.updateTitleErrorIssueSubType')
              : i18n.t('issueTypes.notifications.updateTitleErrorIssueType')
        })
      );
      break;
    }
    case ISSUE_TYPES_UPDATE_START: {
      const {onSuccessUpdateIssueType, onSuccessUpdateIssueTypeMappings} = action.payload;
      const issueTypeForEdit = getIssueTypeForEdit(state);
      const {id, parentId, title, isActive} = issueTypeForEdit;
      const pendingIssueType = getPendingIssueType(state);
      let shouldUpdateIssueType = false;

      const changeObj = {};
      if (!isNullOrUndefined(pendingIssueType.title) && pendingIssueType.title !== title) {
        changeObj.title = pendingIssueType.title;
        shouldUpdateIssueType = true;
      }

      if (!isNullOrUndefined(pendingIssueType.isActive) && pendingIssueType.isActive !== isActive) {
        changeObj.isActive = pendingIssueType.isActive;
        shouldUpdateIssueType = true;
      }

      const mapper = mapping => ({
        attributeDefinitionId: mapping.attributeDefinitionId,
        isRequired: mapping.isRequired
      });

      const originalAttributeMappings = getFilteredIssueTypeAttributeMappingsByIssueTypeId(state, id).map(mapper);
      const currentAttributeMappings = getSelectedIssueTypeAttributes(state).map(mapper);

      if (shouldUpdateIssueType) {
        store.dispatch({
          type: ISSUE_TYPES_UPDATE_API,
          payload: issuesV2Api.updateIssueType(id, parentId, changeObj),
          meta: {id, parentId, ...changeObj, onSuccess: onSuccessUpdateIssueType}
        });
      } else {
        onSuccessUpdateIssueType && onSuccessUpdateIssueType();
      }

      if (!lodashIsEqual(originalAttributeMappings, currentAttributeMappings)) {
        store.dispatch(updateIssueTypeAttributesAction(issueTypeForEdit, onSuccessUpdateIssueTypeMappings));
      } else {
        onSuccessUpdateIssueTypeMappings && onSuccessUpdateIssueTypeMappings();
      }
      break;
    }
    case ISSUE_TYPES_UPDATE_API_FULFILLED: {
      action.meta.onSuccess();
      if (!isNullOrUndefined(action.meta.isActive)) {
        handleIssueTypeStatusUpdateFulfilled();
      }
      break;
    }
    case ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API_REJECTED:
    case ISSUE_TYPES_UPDATE_API_REJECTED: {
      store.dispatch(
        showNotificationAction({
          level: NotificationLevels.ERROR,
          type: NotificationTypes.SNACKBAR,
          message:
            action.meta && action.meta.parentId
              ? i18n.t('issueTypes.notifications.updateErrorIssueSubType')
              : i18n.t('issueTypes.notifications.updateErrorIssueType')
        })
      );
      break;
    }
    /*
       Customization metadata includes Issue Types, Issue Attribute Definitions and Issue Attribute Mappings.
       Attribute Mappings currently need to be fetched only after we have both definitions and types. (will be resolved in BTLV-9386).
       Therefore, when we trigger customization data fetch, we want to fetch both types and attributes simultaneously and then, when both of them are finished we will fetch the mappings.
       Due to that, we have in each Types and Attributes Definitions "finished fetch" actions handling to fetch the mappings if needed.
       However, some calls might fail, so in Admin page there's a "retry" button (other views will also have it as part of BTLV-9386 as well).
       The retry generically calls this action, so Customization data also conditionally knows what to do in case one of the requests fail. with the below guards.
       */
    // TODO: Simply fetch logic - BTLV-9386
    case FIELD_ISSUES_FETCH_CUSTOMIZATION_METADATA: {
      const issueTypesFetched = isIssueTypesAdminListFetched(state);
      const isLoadingIssueTypes = isLoadingIssueTypesAdminList(state);
      const isLoadingIssueAttributeDefinitions = isLoadingIssueAttributesDefinitions(state);
      const issueAttributesDefinitionsFetched = isIssueAttributesDefinitionsFetched(state);
      const issueAttributesMappingsFetched = isIssueAttributesMappingsFetched(state);
      const isLoadingIssueAttributeMappings = !isLoadingIssueAttributesMappings(state);

      !isLoadingIssueTypes && !issueTypesFetched && store.dispatch(fetchIssueTypesAction());
      !isLoadingIssueAttributeDefinitions &&
        !issueAttributesDefinitionsFetched &&
        store.dispatch(fetchIssueAttributesDefinitionsAction());
      issueTypesFetched &&
        issueAttributesDefinitionsFetched &&
        !issueAttributesMappingsFetched &&
        !isLoadingIssueAttributeMappings &&
        store.dispatch(fetchIssueAttributesMappingsAction());

      break;
    }
    case ISSUE_ATTRIBUTES_MAPPINGS_FETCH_FINISHED: {
      store.dispatch({
        type: ISSUE_TYPES_SET_ATTRIBUTE_MAPPINGS,
        payload: getIssueAttributesMappingsMappedEntities(state).asMutable(),
        meta: {containerId: getContainerId(state)}
      });
      break;
    }
    case ISSUE_TYPES_SELECT_FOR_EDIT: {
      const selectedAttributes = isNullOrUndefined(action.payload.id)
        ? []
        : getFilteredIssueTypeAttributeMappingsByIssueTypeId(state, action.payload.id);
      store.dispatch(setSelectedIssueTypeAttributesAction(selectedAttributes));
      break;
    }

    case ISSUE_TYPES_SET_SELECTED_ATTRIBUTE_DEFINITIONS: {
      const selectedDefinitionIds = action.payload.definitions;
      const currentAttributeMappings = getCurrentEditingIssueTypeAttributeMappings(state);
      const currentSelectedAttributeMappings = getSelectedIssueTypeAttributes(state);
      const issueAttributesDefinitionsEntitiesMap = getIssueAttributesDefinitionsEntitiesMap(state);
      const newAttributeMappings = [
        ...currentSelectedAttributeMappings,
        ...selectedDefinitionIds.map(definitionId => {
          const currentMapping = currentAttributeMappings.find(
            mapping => mapping.attributeDefinitionId === definitionId
          );
          if (currentMapping) {
            return currentMapping;
          } else {
            return {
              attributeDefinitionId: definitionId,
              isRequired: lodashGet(issueAttributesDefinitionsEntitiesMap, `[${definitionId}].isRequiredDefault`, false)
            };
          }
        })
      ];
      store.dispatch(setSelectedIssueTypeAttributesAction(newAttributeMappings));
      break;
    }

    case ISSUE_TYPES_REMOVE_SELECTED_ATTRIBUTE: {
      const currentSelectedAttributeMappings = getSelectedIssueTypeAttributes(state);
      const idToRemove = action.payload.id;
      const updatedAttributeMappings = currentSelectedAttributeMappings.filter(
        mapping => mapping.attributeDefinitionId !== idToRemove
      );
      store.dispatch(setSelectedIssueTypeAttributesAction(updatedAttributeMappings));
      break;
    }

    case SHOW_ISSUE_TYPES_EDIT_MODAL:
      next(action);
      if (!action.payload.visible && !action.meta.shouldOpenCreateAttributeModal) {
        store.dispatch(selectIssueTypeForEdit(null));
        store.dispatch(trackEvent(issueAllIssuesTypesModalVisit()));
      }
      return;

    case ISSUE_TYPES_UPDATE_NOTIFICATION_SHOW: {
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.TOAST,
          level: NotificationLevels.SUCCESS,
          message: action.payload.isSubType
            ? i18n.t('issueTypes.notifications.updateSuccessIssueSubType')
            : i18n.t('issueTypes.notifications.updateSuccessIssueType')
        })
      );
      break;
    }
  }

  // eslint-disable-next-line consistent-return
  return next(action);
};
